import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import ButtonRowView from './View';
import schema from './schema';
import './style.css';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const initialisedData = data;

  const imageItem = Array.isArray(initialisedData.backgroundImage)
    ? initialisedData.backgroundImage[0]
    : initialisedData.backgroundImage;

  const imageUrl = imageItem?.['@id']
    ? `${imageItem['@id']}/@@images/image`
    : imageItem?.download || '';

  const buttonSource = initialisedData.buttonSource || 'contained';

  return (
    <>
      <ButtonRowView {...props} />

      {selected && (
        <SidebarPortal selected={selected}>
          <BlockDataForm
            schema={{
              ...schema(props),
              fieldsets: schema(props).fieldsets.map((fs) => {
                let fields = fs.fields;
                
                // Filter out backgroundColor if there's an image
                if (imageUrl) {
                  fields = fields.filter((f) => f !== 'backgroundColor');
                }
                
                // Show/hide fields based on buttonSource
                if (buttonSource === 'contained') {
                  // Show only containedItemTypes
                  fields = fields.filter((f) => 
                    !['useH2', 'useH3', 'buttons'].includes(f)
                  );
                } else if (buttonSource === 'toc') {
                  // Show only useH2 and useH3
                  fields = fields.filter((f) => 
                    !['containedItemTypes', 'buttons'].includes(f)
                  );
                } else if (buttonSource === 'custom') {
                  // Show only buttons
                  fields = fields.filter((f) => 
                    !['useH2', 'useH3', 'containedItemTypes'].includes(f)
                  );
                }
                
                return { ...fs, fields };
              }),
            }}
            title="Button Row Block"
            onChangeField={(id, value) =>
              onChangeBlock(block, { ...data, [id]: value })
            }
            onChangeBlock={(id, newData) =>
              onChangeBlock(id, {
                ...data,
                ...newData,
                backgroundColor: newData.backgroundImage ? undefined : initialisedData.backgroundColor,
              })
            }
            block={block}
            formData={initialisedData}
          />
        </SidebarPortal>
      )}
    </>
  );
};

export default Edit;